export default {"src":"/_next/static/media/DAR.afff76a9.svg","height":18,"width":18};